<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
    <div class="d-flex flex-row bd-highlight my-3">
        <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
            <div class="list-group my-1" *ngFor="let item of items | async">
                <a class="list-group-item list-group-flush" (click)="routeToBusinessDetailPage(item.id)" routerLink="">                
                    <div class="media">                        
                        <img *ngIf="!item.profilePictureUrl" [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <img *ngIf="item.profilePictureUrl" [src]="item.profilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <div class="media-body">
                            <div class="h5 m-0" >{{ item.name }}</div>
                            <p class="badge badge-dark p-1">{{item.category}}</p>
                            <p>{{item.phone}}
                                <span *ngIf="item.phone && item.email">|</span> 
                                {{item.email}} 
                                <!-- <span *ngIf="item.email && item.websiteUrl">|</span> 
                                {{item.websiteUrl}} -->
                            </p>                            
                        </div>       
                    </div>          
                </a>   
            </div>
        </div>
    </div>
</div>
